module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-4.c0358cc7.jpg";